import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { getStyledText } from '../../helpers/styled';
import Config from '../../config';
export var TextVariant1 = withTheme(getStyledText('smallBody', {
  tag: 'span',
  lineHeight: 'compact'
})(function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css(["text-transform:uppercase;letter-spacing:0.8px;font-family:", ";", ";"], coreTheme.ff_sec_bold, Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        line-height: 24px;\n      "]))));
}));
export var TextVariant2 = styled(TextVariant1).withConfig({
  displayName: "styles__TextVariant2",
  componentId: "sc-1owrwsf-0"
})(["letter-spacing:0.2px;text-transform:unset;"]);
export var Ribbon = styled.div.withConfig({
  displayName: "styles__Ribbon",
  componentId: "sc-1owrwsf-1"
})(["display:inline-block;"]);
export var Container = withTheme(styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1owrwsf-2"
})(["display:flex;flex-direction:row;align-items:center;", ""], function (p) {
  var bgColor = p.color === 'secondary' ? p.coreTheme.cl_sec_l1 : p.coreTheme.cl_pri_d2;
  var textColor = p.color === 'secondary' ? p.coreTheme.cl_sec_d2 : p.coreTheme.cl_pri_d2;
  return css(["span{color:", ";}", "{background-color:", ";}"], textColor,
  /* sc-sel */
  BadgeIconContainer,
  /* sc-value */
  bgColor);
}));
export var Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1owrwsf-3"
})(["display:flex;align-items:center;"]);
export var BadgeIconContainer = styled.div.withConfig({
  displayName: "styles__BadgeIconContainer",
  componentId: "sc-1owrwsf-4"
})(["width:36px;height:36px;border-radius:8px;display:flex;align-items:center;justify-content:center;+ ", "{margin-left:8px;}"],
/* sc-selector */
Content);